export const AppEnv = () => {
    return process.env.REACT_APP_ENV
}

export const ShowEnvBanner = () => {
    return process.env.REACT_APP_SHOW_ENV_BANNER === 'true'
}

// Dedicated per-env kill switch for the Console feature (button + all
// /console/* API traffic)
export const DisableConsole = () => {
    return process.env.REACT_APP_DISABLE_CONSOLE === 'true'
}

export const WebSocketUrl = () => {
    return process.env.REACT_APP_WEB_SOCKET_URI
}

export const APIUrl = () => {
    return process.env.REACT_APP_API_URL
}

export const FocusBaseUrl = () => {
    return process.env.REACT_APP_FOCUS_MODE_URL
}

export const ConsoleApiUrl = () => {
    return process.env.REACT_APP_CONSOLE_API_URL
}

export const ConsoleApiKey = () => {
    return process.env.REACT_APP_CONSOLE_MODE_API_KEY
}

export const JoiApiUrl = () => {
    return process.env.REACT_APP_JOI_API_URL
}



// export const SetUserId = (item, value) => {
//     localStorage.setItem(item, JSON.stringify(value))
// }
// export const GetUserId = () => {
//     return localStorage.getItem('userId') || null
// }
// export const SetOktaAuthData = (item, value) => {
//     localStorage.setItem(item, JSON.stringify(value))
// }
// export const GetOktaAuthData = () => {
//     return JSON.parse(localStorage.getItem("auth") || null);
// }